import { render, staticRenderFns } from "./ItemsView.vue?vue&type=template&id=772dd138&scoped=true"
import script from "./ItemsView.vue?vue&type=script&lang=js"
export * from "./ItemsView.vue?vue&type=script&lang=js"
import style0 from "./ItemsView.vue?vue&type=style&index=0&id=772dd138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772dd138",
  null
  
)

export default component.exports